import React from 'react';

import { MainLayout } from '@components';
import Profile from './Profile';

const ProfilePage = props => (
  <MainLayout footer="main" children={<Profile {...props} />} />
);

export default ProfilePage;
